/**
 * Sanitize a URL that came from untrusted event data before using it as an
 * `href`, `src`, or CSS `url()`. Only https: (and data: images) are allowed.
 * Returns `undefined` when the URL is unsafe.
 */
export function sanitizeUrl(url: string | undefined | null): string | undefined {
  if (!url) return undefined;
  const trimmed = url.trim();
  try {
    const parsed = new URL(trimmed);
    if (parsed.protocol === 'https:') {
      return parsed.href;
    }
    return undefined;
  } catch {
    return undefined;
  }
}

/**
 * Allow https: URLs and data:image/* URLs. Used for image sources where a
 * profile picture may be embedded as a data URI.
 */
export function sanitizeImageUrl(url: string | undefined | null): string | undefined {
  if (!url) return undefined;
  const trimmed = url.trim();
  if (/^data:image\/(png|jpe?g|gif|webp|svg\+xml);/i.test(trimmed)) {
    return trimmed;
  }
  return sanitizeUrl(trimmed);
}
